import axios, { AxiosError, AxiosResponse } from "axios";
import { getAuthUser } from "src/services/Authentication/AuthenticationService";
import { removeAuthUser } from "../services/Authentication/AuthenticationService";
import store from "../store/index";
import { login, logout } from "src/store/Authentication/authActions";
import { IApiResponse } from "../shared/models/IApiResponse";
import { alertFromAPIResponse } from "src/shared/services/AlertService";
import { AuthAPIService } from "./Authentication/API_AuthService";
import { removeStoreXUser } from "src/services/Stores/FilteredStoreService";

const axiosApiInstanceFile = axios.create();
axiosApiInstanceFile.defaults.baseURL = process.env.REACT_APP_RETAIL_API_URL;

let isRefreshing = false;
let failedQueue: any = [];

const processQueue = (error, token: string | null | undefined = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const axiosDefaultHeaders = (token: string) => {
  return {
    Authorization: `Bearer ${token}`,
    // Accept: "application/json",
    // "Content-Type": "application/json",
    'Content-Type': 'multipart/form-data'
  };
};

// Append Token
axiosApiInstanceFile.interceptors.request.use(
  async config => {
    const token = getAuthUser().user?.jwtToken || "";
    config.headers = axiosDefaultHeaders(token);
    return config;
  },
  error => {
    //console.log(`Request Interceptor: ${error}`);
    Promise.reject(error);
  }
);

axiosApiInstanceFile.interceptors.response.use(
  (response): any => {
    const responseData = response.data as IApiResponse;
    alertFromAPIResponse(responseData);

    console.log(response);
    return response;
  },
  async function (err) {
    const error = err as AxiosError;
    const originalRequest = error.config;

    if (error.response?.status !== 401) {
      const { data } = (error.response as AxiosResponse<IApiResponse>) || {};
      
      if (data) {
        alertFromAPIResponse(data)
      }
      if (error.response?.status == 403) {
        alertFromAPIResponse({
          success: false,
          message: 'No tiene permiso para realizar esta operación.',
          data: {},
          errors: [],
          total: 0
        } as IApiResponse)
      }

      if (error.response?.status == 401) {
        alertFromAPIResponse({
          success: false,
          message: 'Su sesión ha finalizado',
          data: {},
          errors: [],
          total: 0
        } as IApiResponse)
      }

      return Promise.reject(error)
    }

    const refreshToken = getAuthUser().user?.refreshToken || "";

    return await AuthAPIService.refreshToken(refreshToken)
      .then(auth => {
        store.dispatch(login(auth));
        axiosApiInstanceFile.defaults.headers = axiosDefaultHeaders(
          auth.jwtToken
        );
        originalRequest.headers = axiosDefaultHeaders(auth.jwtToken);

        return Promise.resolve(axiosApiInstanceFile(originalRequest));
      })
      .catch(error => {
        removeAuthUser();
        removeStoreXUser();
        store.dispatch(logout());
        return Promise.reject(error);
      });
  //   const refreshToken = getAuthUser().user?.refreshToken || "";

  //   return await AuthAPIService.refreshToken(refreshToken)
  //     .then(auth => {
  //       store.dispatch(login(auth));
  //       axiosApiInstanceFile.defaults.headers = axiosDefaultHeaders(
  //         auth.jwtToken
  //       );
  //       originalRequest.headers = axiosDefaultHeaders(auth.jwtToken);

  //       return Promise.resolve(axiosApiInstanceFile(originalRequest));
  //     })
  //     .catch(error => {
  //       removeAuthUser();
  //       store.dispatch(logout());
  //       return Promise.reject(error);
  //     });
  }
);

export default axiosApiInstanceFile;
